import React from "react";
import RVEORenderBeneficiariesSection from "./RVEORenderBeneficiariesSection";
import { FamilyGroup } from "../../../../interfaces/rveoSimulations";

interface RVEOBeneficiariesSectionProps {
  familyGroup: FamilyGroup[];
}

const TITULAR_RELATIONSHIP = "T";

const RVEOBeneficiariesSection: React.FC<RVEOBeneficiariesSectionProps> = ({
  familyGroup,
}) => {
  if (!familyGroup || familyGroup.length === 0) return null;

  const titulars: FamilyGroup[] = [];
  const beneficiaries: FamilyGroup[] = [];

  familyGroup.forEach((beneficiary) => {
    if (beneficiary.parentesco === TITULAR_RELATIONSHIP) {
      titulars.push(beneficiary);
      return;
    }
    beneficiaries.push(beneficiary);
  });


  return (
    <>
      <RVEORenderBeneficiariesSection
        title="Titular"
        items={titulars}
      />
      <RVEORenderBeneficiariesSection
        title="Beneficiarios"
        items={beneficiaries}
      />
    </>
  );
};

export default RVEOBeneficiariesSection;
